import { createAsyncThunk } from '@reduxjs/toolkit';
import { IStructuredEssayQuestion } from '.';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { UserApiPaths } from '../../dataProvider/APIPaths';

export interface IStudentAnswer {
  subQuestionId: string;
  answer: string;
}

export interface IGetAiResponse {
  questionId: string;
  answers: IStudentAnswer[];
}

export interface ISubQuestionVerdict {
  subQuestionId: string;
  verdict: 'Correct' | 'Partially Correct' | 'Incorrect' | string;
  givenMarks: number;
  analysis: string;
}

export interface IAiResponse {
  questionId: string;
  evaluations: ISubQuestionVerdict[];
}

const StructuredEssayApiDataProvider = new APIDataProvider<
  IStructuredEssayQuestion[]
>();
const AiResponseApiDataProvider = new APIDataProvider<IAiResponse>();

export const getRandomStructuredQuestionsBySubTopic = createAsyncThunk(
  'structuredEssay/random/subTopic',
  async (subTopic: string) => {
    const response = await StructuredEssayApiDataProvider.getById(
      `${UserApiPaths.structuredEssayQuestions}/random/${subTopic}`
    );

    return response.data;
  }
);

export const getAiResponse = createAsyncThunk(
  'structuredEssay/aiResponse',
  async (data: IGetAiResponse) => {
    const response = await AiResponseApiDataProvider.create(
      `${UserApiPaths.structuredEssayQuestions}/aiResponse`,
      data
    );
    return response.data;
  }
);
